import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as n, normalizeClass as o, createElementVNode as l } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconMiro",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(i).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(a, t, r, _, f, e) {
  return d(), n("svg", {
    "aria-label": r.ariaLabel,
    class: o([e.iconSizeClass, "d-icon d-icon--miro"]),
    "data-qa": e.dataQA,
    "aria-hidden": e.ariaHidden,
    role: "img",
    "data-name": "Miro",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    l("path", {
      d: "M18.774 2H5.226A3.226 3.226 0 0 0 2 5.226v13.548A3.226 3.226 0 0 0 5.226 22h13.548A3.226 3.226 0 0 0 22 18.774V5.226A3.226 3.226 0 0 0 18.774 2Z",
      fill: "#FFD02F"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M15.506 5.125h-1.951l1.626 2.946-3.577-2.946H9.652l1.789 3.601-3.74-3.601H5.75l1.951 4.583-1.951 9.167h1.951l3.74-9.821-1.789 9.821h1.952L15.18 8.399l-1.626 10.476h1.951l3.577-11.458-3.577-2.292Z",
      fill: "#050038"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=miro.js.map
